module.exports = __webpack_public_path__ + "img/Pic_Services-4.f750f650.jpg";